export type GuidString = string;
export type Integer = number;
export type Dictionary<TKey extends number | string, TValue> = { [key: string]: TValue };
export type StringDictionary = Dictionary<string, string>;

export enum YesNo {
    Yes = -1,
    No = -2
}
